import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryHardwareIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-hardware"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-accent-primaryActive"
      d="M3.94701 10.7513L3.00521 9.56609C2.74066 9.23805 2.79357 8.76186 3.12161 8.50789L11.6507 1.69308C11.9788 1.42853 12.455 1.48144 12.7089 1.80948L13.6507 2.99466C13.9153 3.32271 13.8624 3.7989 13.5343 4.05287L5.00521 10.8677C4.68775 11.1322 4.21156 11.0793 3.94701 10.7513Z"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M15.6826 19.6085L20.381 22.381C20.7937 22.6244 21.2805 22.2222 21.1111 21.7672L19.2275 16.5503C19.1323 16.2751 18.9947 16.0212 18.8148 15.7884L17.8876 14.5805L14.8041 18.7513C14.799 18.7584 14.7937 18.7652 14.7882 18.7718L14.8783 18.8889C15.1006 19.1852 15.3651 19.4286 15.6826 19.6085ZM14.2743 18.1043L17.3741 13.9116L16.5315 12.814L13.4305 17.0083L14.2743 18.1043ZM15.1986 11.0778L16.0166 12.1433L12.9162 16.3402L12.0958 15.2746L15.1986 11.0778ZM11.5815 14.6066L14.685 10.4088L13.8282 9.29276L10.7235 13.4922L11.5815 14.6066ZM12.4995 7.56186L13.3185 8.62876L10.2095 12.8245L9.39285 11.7638L12.4995 7.56186ZM8.87857 11.0958L11.9859 6.89289L11.1217 5.76721L7.1958 8.91007L8.87857 11.0958Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryHardwareIcon.displayName = 'CategoryHardwareIcon';
